import { IFooter } from '../models/footer.models';
import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { FooterActions } from '../actions';

export interface FooterState {
  socialMediaFooter: IFooter;
  socialMediaFooterError: string;
  footerNavigation: IFooter;
  footerNavigationError: string;
}

export const initialState: FooterState = {
  socialMediaFooter: null,
  socialMediaFooterError: null,
  footerNavigation: null,
  footerNavigationError: null,
};

export const footerState = createFeatureSelector<FooterState>('footer');

export const selectSocialMediaFooter = createSelector(
  footerState,
  state => state.socialMediaFooter,
);

export const selectFooterNavigation = createSelector(
  footerState,
  state => state?.footerNavigation,
);

export const FooterReducer = createReducer(
  initialState,
  on(FooterActions.loadFooterNavigation, (state: FooterState) => {
    return {
      ...state,
      footerNavigation: null,
    };
  }),
  on(FooterActions.loadFooterNavigationSuccess, (state: FooterState, action) => {
    return {
      ...state,
      footerNavigation: action.footerNavigation,
    };
  }),
  on(FooterActions.loadFooterNavigationFail, (state: FooterState, action) => {
    return {
      ...state,
      footerNavigationError: action.resError,
    };
  }),
  on(FooterActions.loadSocialMediaFooter, (state: FooterState) => {
    return {
      ...state,
      socialMediaFooter: null,
    };
  }),
  on(FooterActions.loadSocialMediaFooterSuccess, (state: FooterState, action) => {
    return {
      ...state,
      socialMediaFooter: action.socialMediaFooter,
    };
  }),
  on(FooterActions.loadSocialMediaFooterFail, (state: FooterState, action) => {
    return {
      ...state,
      socialMediaFooterError: action.resError,
    };
  }),
);
